import apiClient from './api-client';

export default function eventReportService(eventName, payload) {
    try {
        const response = apiClient.post('event/report', {
            evento: eventName,
            data: payload
        }, {}, { action: 'event_report' });
        return response.data;
    } catch (error) {
        console.error(error);
        return error;
    }
}